import request from './requestUtils'

export interface RebucketExperimentsResponse {
  optimizelyExperiments: Record<string, App.OptimizelyExperimentDetails | undefined>
  chertoExperiments?: Record<string, App.ChertoExperimentDetails | undefined>
  optimizelyFeatureFlags: App.OptimizelyFeatureFlag
  resolvedTrackingId: string
}

export interface RebucketExperimentsRequestBody {
  regionCode: string
}

/**
 * Re-bucket experiments after user login.
 *
 * Calls the SSR re-bucketing endpoint with the visible storefront region so
 * audience targeting stays aligned when the POST URL has no `/{region}/` prefix.
 */
export async function rebucketExperiments(
  body: RebucketExperimentsRequestBody,
): Promise<RebucketExperimentsResponse | undefined> {
  return await request.post<RebucketExperimentsResponse, RebucketExperimentsRequestBody>(
    '/api/experiments/rebucket',
    body,
    {},
    '',
  )
}
